<style lang="scss" scoped>
.actions {
	margin-left: auto !important;
}
</style>
<template lang="pug">
div
	app-header(v-if="!isOrg")
		template(slot='header')
			.d-flex
				h1 Settings
				el-button(type='primary', :loading='loading', @click='save', e2e="settings").actions {{ loading ? "Saving settings..." : "Save settings" }}
	settings-form(v-if="providerCode === 'apl'" ref="settings_form" v-on:Saving="loading = $event")
	settings(v-else ref="settings_form" v-on:Saving="loading = $event", :type="isOrg ? 'organisation' : 'school'")
</template>
<script>
import Settings from "./includes/Settings";
import SettingsForm from "./includes/apple/SettingsForm";
export default {
	components: {
		Settings,
		SettingsForm
	},
	data() {
		return {
			loading: false
		};
	},
	props: {
		isOrg: Boolean,
	},
	methods: {
		save() {
			this.$refs.settings_form.save();
		}
	}
};
</script>